













































import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

import { Meta } from '@/helpers/decorators'
import LanguageDropdown from '@/components/elements/LanguageDropdown.vue'
import TopBarCtaButtons from '@/views/all/header/TopBarCtaButtons.vue'
import TopBarLinks from '@/views/all/header/TopBarLinks.vue'

@Component({
  components: {
    LanguageDropdown,
    TopBarLinks,
    TopBarCtaButtons
  }
})
export default class Default extends Vue {
  title = null

  @Getter('isAdmin', { namespace: 'user' }) isAdmin

  @Meta
  updatetopbarTitle() {
    return {
      changed: (metas) => {
        this.title = metas.titleChunk
      }
    }
  }

  get isProduction(): boolean {
    return this.$env === 'production'
  }
}
